import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46b40d38"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pageBox layoutBox" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("操作文档")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("详情")
const _hoisted_4 = {
  key: 0,
  class: "page_main"
}
const _hoisted_5 = { class: "page_main_title" }
const _hoisted_6 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBox = _resolveComponent("NavBox")!
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_ImgBox = _resolveComponent("ImgBox")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_NavBox, {
      selectedItem: _ctx.selectedItem,
      "onUpdate:selectedItem": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedItem) = $event))
    }, null, 8, ["selectedItem"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_page_header, {
        content: "detail",
        onBack: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        content: _withCtx(() => [
          _withDirectives(_createVNode(_component_el_breadcrumb, { "separator-icon": "arrow-right-bold" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }),
              _createVNode(_component_el_breadcrumb_item, {
                onClick: _ctx.onBreadcrumb,
                class: "pointer"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.navTitle), 1)
                ]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.navTitle]
          ])
        ]),
        _: 1
      }),
      (_ctx.info)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.info.name), 1),
            _createElementVNode("div", {
              class: "page_main_details",
              innerHTML: _ctx.info.content,
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.imageChgange($event)))
            }, null, 8, _hoisted_6)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ImgBox, {
      ref: "imgBoxRef",
      src: _ctx.imagePreview,
      class: "imagePreview",
      srcList: _ctx.imgSrcList
    }, null, 8, ["src", "srcList"])
  ]))
}